import { Injectable } from '@angular/core';
import { HubConnection, HubConnectionBuilder } from '@microsoft/signalr';
import { environment } from '../../environments/environment';
import { BffService } from './BffService';

@Injectable({ providedIn: 'root' })
export class SignalRService {
  private hubConnection!: HubConnection;
  private readonly hubUrl = `${environment.backend.baseUrl}${environment.backend.apiUrl}/notificationHub`;

  constructor(private bff: BffService) {}

  public startConnection(): void {
    void (async () => {
      try {
        await this.bff.ensureCsrf();
      } catch {
        // ignore; fall back to cookie read below
      }

      const token = this.bff.getCsrfToken() || this.readCookie('XSRF-TOKEN');
      this.hubConnection = new HubConnectionBuilder()
        .withUrl(this.hubUrl, {
          headers: { 'X-CSRF-TOKEN': token || '' },
          withCredentials: true,
        })
        .withAutomaticReconnect()
        .build();

      try {
        await this.hubConnection.start();
        console.log('SignalR connection started');
      } catch (err) {
        console.error('SignalR error:', err);
      }
    })();
  }

  public stopConnection(): void {
    if (!this.hubConnection) return;
    this.hubConnection.stop().then(() => console.log('SignalR connection stopped'));
  }

  public onNotification(callback: (message: string) => void): void {
    if (!this.hubConnection) return;
    this.hubConnection.on('ReceiveNotification', callback);
  }

  private readCookie(name: string): string | null {
        const nameEQ = name + '=';
        const ca = document.cookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) === ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    }
}
